export class Ward {
  id!: number;
  ward_number!: number;
  ward_name?: string;
  ward_member_name?: string;
  contact_number?: string;
  subdomain!: string;
  assessment_count?: number; // Number of assessments in this ward
}
